module.exports = __webpack_public_path__ + "media/images/signatures/cover-bg-dbd85a3a0e80f9855cc82370de0dbd68.png";